import React from 'react'
// components
import Dialog, { DialogProps } from '@mui/material/Dialog'
// utils
import { get } from 'lodash'

interface Props extends Omit<DialogProps, 'open'> {
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  isOpen: boolean
  onClose?: () => void
  hideModal?: () => void
  disableBackdropClick?: boolean
}

const Modal: React.FC<Props> = ({ children, width, isOpen, hideModal, onClose, disableBackdropClick, disableEscapeKeyDown, ...rest }) => {
  const handleOnClose = (_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return
    }

    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return
    }

    onClose?.()
    hideModal?.()
  }

  return (
    <Dialog
      fullWidth
      open={isOpen}
      scroll={'paper'}
      maxWidth={width}
      onClose={handleOnClose}
      {...rest}
      PaperProps={{
        ...get(rest, 'PaperProps', {}),
        style: {
          overflow: 'hidden',
          ...get(rest, 'PaperProps.style', {})
        }
      }}>
      {children}
    </Dialog>
  )
}

export default Modal
